import Route from '@ember/routing/route';
import { get } from '@ember/object';
import { service } from '@ember/service';
import logger from 'donor-elf-web/lib/logger';
import ExpiredFundTokenError from 'donor-elf-web/adapters/expired-fund-token-error';
import { isPresent } from '@ember/utils';
import type CurrentUser from 'donor-elf-web/services/current-user';
import type Router from '@ember/routing/router';
import type FundsService from 'donor-elf-web/services/funds-service';
import type SessionService from 'ember-simple-auth/services/session';
import type Transition from '@ember/routing/transition';

export default class FundsRoute extends Route {
  @service declare currentUser: CurrentUser;
  @service declare fundsService: FundsService;
  @service declare router: Router;
  @service declare session: SessionService;

  async beforeModel(transition: Transition) {
    await this.session.requireAuthentication(transition, 'login');

    return this.currentUser.load().then(() => {
      if (this.currentUser.coachingOnly) {
        this.router.transitionTo('coaching');
      }
      if (isPresent(this.currentUser.afterLoginRoute)) {
        this.router.transitionTo(this.currentUser.afterLoginRoute);
      }
    });
  }

  error = (error: any, transition: Transition) => {
    if (error instanceof ExpiredFundTokenError) {
      logger.error(
        `invalid fund token while going to route: ${transition.to?.name}. From route: ${this.router.currentRouteName}`,
      );
    }
    return true;
  };
}
